import script from "./MobileReportHistoryItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileReportHistoryItem.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/mobile/ticket.css?vue&type=style&index=0&id=650cbea5&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-650cbea5"]])

export default __exports__